import Recat, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Select, message, Spin, Table } from 'antd'
import { SGeneralForms } from 'shj-components'
export const AddOrEditForm = Recat.forwardRef((props: any, ref) => {
  const { editData } = props
  const formRef: any = useRef()
  const [spinning, setSpinning] = useState(false)
  const [dataSource, setDataSource] = useState<any>([])
  useEffect(() => {
    initFn()
  }, [])
  useImperativeHandle(ref, () => ({
    getValue: () => formRef.current?.onFormRef()?.getFieldsValue(),
    validateFields: () => formRef.current?.onFormRef()?.validateFields(),
  }));
  const initFn = async () => {
    if (editData) {
      setSpinning(true)
      setDataSource(editData.dtlResponseList || [])
      formRef.current?.onFormRef()?.setFieldsValue({...editData})
      setSpinning(false)
    }
  }
  const getOptions = async () => {
    return Promise.resolve({
    })
  }
  const columns = [
    {
      title: '转出收款单号',
      dataIndex: 'sourceTransactionCode',
      key: 'sourceTransactionCode',
    },
    {
      title: '支付方式',
      dataIndex: 'sourceTransactionPaymentMethodName',
      key: 'sourceTransactionPaymentMethodName',
    },
    {
      title: '收款金额',
      dataIndex: 'sourceTransactionAmount',
      key: 'sourceTransactionAmount',
    },
    {
      title: '转款金额',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: '金蝶转入收款单号',
      dataIndex: 'targetTransactionCode',
      key: 'targetTransactionCode',
    },
  ]
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        httpOptionsFn={getOptions}
        isDetail={true}
        layout="vertical"
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '金蝶退款记录单号',
                name: 'refundBillNo',
                spanCol: 8,
              },
              {
                label: '转出订单号',
                name: 'sourceOrderNo',
                spanCol: 8,
              },
              {
                label: '转入订单号',
                name: 'targetOrderNo',
                spanCol: 8,
              },
              {
                label: '转出合同号',
                name: 'sourceContractNo',
                spanCol: 8,
              },
              {
                label: '转入合同号',
                name: 'targetContractNo',
                spanCol: 8,
              },
              {
                label: '金蝶转款状态',
                name: 'kdSyncStatusName',
                spanCol: 8,
              },
              {
                label: '原因说明',
                name: 'description',
                spanCol: 24,
              },
            ],
          },
          {
            title: '金蝶转款明细',
            formName: 'dtlResponseList',
            formItem: [
              {
                label: '',
                name: 'dtlResponseList',
                spanCol: 24,
                children: (
                  <Table
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    size='small'
                  />
                )
              },
            ],
          }
        ]}
      />
    </Spin>
  )
})
